import { useState, useEffect } from "react";
import Nav from "./nav";
import Footer from "./Footer";
const Photo = () => {

    const [img,setImg]= useState("");

    useEffect(()=>{
        let qurl = window.location.href;
        let query= qurl.split('?');
        let url="";
        if(query.length > 1)
        
         url   = "https://sbvmapi.uniservedata.in/api/gallary?"+query[1];
        
        else
            url = "https://sbvmapi.uniservedata.in/api/gallary";
        
       
        callData(url);
    },[]);

   
    const callData=async(url)=>{
        console.log(url);
        const res= await fetch(url);
        const data= await res.json();
        console.log(data.gallary_data);
        setImg (data.gallary_data);
    }

    const getImg = (url) => {
        const parts = url.split("\/");
        const newurl = "https://sbvmapi.uniservedata.in/image/" + parts[1];
       // console.log(newurl);
        return newurl;
    }

    return (
        <>   
            <Nav></Nav>
            <div className="news_section layout_padding" style={{ marginBottom: "2em", backgroundColor: "#F3F4F6", padding: "2rem 0" }}>
  <div className="container">
    <h1 style={{ color: "rgb(183, 110, 121)", textAlign: "center", fontWeight: "bold" }}>Photo gallery</h1>
    <hr style={{ height: '3px', backgroundColor: 'rgb(183, 110, 121)', width: '18%', margin: '14px auto 30px', border: 'none' }} />

    <div className="row">

      <div className="gutter col-lg-12 col-md-12" style={{ backgroundColor: "#fff", padding: "20px", borderRadius: "8px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.05)" }}>
         <div className="row">
                  
                        {img.length > 0 && img.map((image)=>
                        <>
                       
                        <div className="col-lg-4 col-md-4 picGel">
                            <img src={getImg(image.img)}></img>
                         </div>
                        </>                        
                        )}
                    

                    </div>
                    </div>
                </div>
            </div>
            </div>

            <Footer></Footer>
        </>
    );
}

export default Photo;